import { measureHostVisible } from "./probe.js";
export function browserEnvironment() {
    return {
        document: globalThis.document,
        loadPanel: () => import("../panel/module.js"),
        socket: (url) => new WebSocket(url),
        tabStorage: () => globalThis.sessionStorage,
        now: () => Date.now(),
        uuid: () => globalThis.crypto.randomUUID(),
        measure: measureHostVisible,
    };
}
/** Reads a storage key; `null` when storage is blocked or the key is absent. */
export function readStored(storage, key) {
    try {
        return storage().getItem(key);
    }
    catch {
        return null;
    }
}
/** Writes (or with `null` removes) a storage key; a refusal (private mode, quota) is ignored: the key is a convenience. */
export function writeStored(storage, key, value) {
    try {
        if (value === null)
            storage().removeItem(key);
        else
            storage().setItem(key, value);
    }
    catch {
        // Storage refused: the widget works for this page load without it.
    }
}
//# sourceMappingURL=environment.js.map